import {
  Component,
  AfterViewInit,
  OnDestroy,
  inject,
  computed,
} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NovaButton } from '@rds-nova/angular-button';
import { NovaLink } from '@rds-nova/angular-link';

import { DEFAULT_APPLICATION_PHONE_NUMBER } from 'src/app/shared/constants/constants';
import { SimpleDialogComponent } from 'src/app/shared/components/simple-dialog/simple-dialog.component';

import { IdVerificationStore } from 'src/app/features/check-in/store/id-verification-store';
import { TrackedButtonDirective } from 'src/app/core/analytics/directives/tracked-button.directive';
import { TrackedLinkDirective } from 'src/app/core/analytics/directives/tracked-link.directive';

@Component({
  selector: 'app-image-capture-step',
  templateUrl: './image-capture-step.component.html',
  styleUrls: ['./image-capture-step.component.scss'],
  imports: [
    TranslatePipe,
    NovaButton,
    NovaLink,
    SimpleDialogComponent,
    TrackedButtonDirective,
    TrackedLinkDirective,
  ],
})
export class ImageCaptureStepComponent implements AfterViewInit, OnDestroy {
  private readonly idVerificationStore = inject(IdVerificationStore);
  private readonly translateService = inject(TranslateService);

  supportPhoneNumber = DEFAULT_APPLICATION_PHONE_NUMBER;

  t9nPrefix = computed(
    () =>
      `id-verification.capture.${this.idVerificationStore.currentCaptureType()}`,
  );

  hintText = computed(() => {
    const hintType =
      this.idVerificationStore.autoCaptureFeedbackKey() || 'DEFAULT';
    const translationKey = `id-verification.capture.autoCaptureHints.${hintType}`;
    return this.translateService.instant(translationKey);
  });

  async ngAfterViewInit(): Promise<void> {
    await this.idVerificationStore.startAutoCapture();
  }

  ngOnDestroy(): void {
    this.idVerificationStore.stopAutoCapture();
  }
}
